import React from 'react';
import { motion } from 'framer-motion';
import { config } from '../config/config';

const Trust = () => {
  return (
    <section className="trust">
      <div className="trust-inner">
        <motion.div
          className="trust-text"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>
            TRUSTED BY<br />
            {config.stats.happyClients} CLIENTS
          </h2>
          <p>
            {config.stats.yearsExperience} years of honest dealings and premium rates. 
            Gurugram's most preferred gold and silver buyer.
          </p>
        </motion.div>
        <motion.div
          className="trust-stats"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <motion.div
            className="t-stat"
            whileHover={{ scale: 1.1 }}
          >
            <div className="t-num">{config.stats.yearsExperience}</div>
            <div className="t-label">Years Experience</div>
          </motion.div>
          <motion.div
            className="t-stat"
            whileHover={{ scale: 1.1 }}
          >
            <div className="t-num">{config.stats.happyClients}</div>
            <div className="t-label">Happy Clients</div>
          </motion.div>
          <motion.div
            className="t-stat"
            whileHover={{ scale: 1.1 }}
          >
            <div className="t-num">{config.stats.branches}</div>
            <div className="t-label">Branches</div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Trust;
